import React from 'react';
import { ChainCode } from 'enums/common';
import { isKRuokaChain } from 'utils/helpers';

const campaignReportUrls: Record<string, string> = {
  [ChainCode.KCM]: process.env.REACT_APP_CAMPAIGN_REPORT_URL_KCM,
  [ChainCode.KM]: process.env.REACT_APP_CAMPAIGN_REPORT_URL_KM,
  [ChainCode.KSM]: process.env.REACT_APP_CAMPAIGN_REPORT_URL_KSM,
};

interface CampaignReportButtonProps {
  chainId: string;
}

const CampaignReportButton = ({ chainId }: CampaignReportButtonProps) => {
  const campaignReportUrl = campaignReportUrls[chainId];

  return isKRuokaChain(chainId) && campaignReportUrl ? (
    <div className="campaign-report-button">
      <a
        className="btn btn-default btn-medium"
        href={campaignReportUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        Avaa kampanjaraportti-sovellus QlikSensessä
      </a>
    </div>
  ) : null;
};

export default CampaignReportButton;